import { render, staticRenderFns } from "./Sucursales.vue?vue&type=template&id=69232afd&scoped=true"
import script from "./Sucursales.vue?vue&type=script&lang=js"
export * from "./Sucursales.vue?vue&type=script&lang=js"
import style0 from "./Sucursales.vue?vue&type=style&index=0&id=69232afd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69232afd",
  null
  
)

export default component.exports